import FleetsAndPositions from '@src/main/modules/parameters/ui/fleet-positions/components/FleetsAndPositions';

const FleetsAndPositionsPage = () => <FleetsAndPositions />;

export default FleetsAndPositionsPage;
